import CustomizeSpace from '../../../banking/components/spaces/create-edit/CustomizeSpace';
import LegacyCreateEditSpace from '../../../banking/components/spaces/create-edit-legacy/CreateEditSpace';
import {
    BankingExperience,
    useBankingExperience,
} from '../../../common/providers/BankingExperienceProvider';

const CreateEditSpacePage = () => {
    const { bankingExperience } = useBankingExperience();

    return bankingExperience === BankingExperience.CASH_CARD_ACCT ? (
        <CustomizeSpace />
    ) : (
        <LegacyCreateEditSpace />
    );
};

export default CreateEditSpacePage;
